import gql from 'graphql-tag';

export const BrandCreateQuery = gql`
    query BrandCreateQuery {
        editorialSectionTree(EditorialBrand: GOODS4HUB) {
            id
            name
            Parent {
                id
            }
            goodClasses {
                id
                shortname
                shortnameIta
                localId
                name
                nameIta
            }
        }
    }
`;


